export const styles = {
	tabsContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '24px',
		width: '100%',
		overflow: 'hidden',
	},
	tabs: {
		minHeight: '36px',
		width: '100%',
		'& .MuiTabs-indicator': {
			backgroundColor: '#45657B',
			height: '1px',
		},
		'& .MuiTabs-flexContainer': {
			gap: '16px',
		},
		'& .MuiTabs-scrollButtons': {
			color: '#45657B',
			'&.Mui-disabled': {
				opacity: 0.3,
			},
		},
		'& .MuiTabs-scroller': {
			overflow: 'auto',
		},
	},
	tab: {
		minHeight: '36px',
		padding: '6px 4px',
		textTransform: 'uppercase',
		fontFamily: 'Roboto',
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '24px',
		letterSpacing: '0.4px',
		color: 'rgba(0, 0, 0, 0.6)',
		'&.Mui-selected': {
			color: '#45657B',
		},
		minWidth: 'auto',
	},
}
